<template>
  <div class="row">
    <div class="flex md4">
      <va-card title="Details">
        <div class="row">
          <div class="flex md8 sm10 xs12">
            <va-input v-model="item.name" label="Name" />
          </div>
        </div>
        <div class="row">
          <va-button @click="mainSave" :disabled="!hasDataChanged">Save</va-button>
          <va-button @click="mainCancel" :disabled="!hasDataChanged">Cancel</va-button>

          <span v-if="showSaving" class="notif">Saving...</span>
          <span v-if="showSaved" class="notif">Saved</span>
          <span v-if="showChangesWarning" class="notif" style="color: red">Save or Cancel changes before selecting another account</span>
        </div>
      </va-card>
    </div>

    <div class="flex md8">
      <div class="column">
        <div class="flex md12">
          <va-card title="Sites">
            <template slot="actions">
              <va-button @click="addSiteToAccount"> Add </va-button>
            </template>

            <va-data-table :fields="fields" :data="accountSitesList" no-pagination no-data-label="No sites" hoverable ext-link-field="__slot:extlink" v-if="!accountSitesListLoading" style="height: 20vh">
              <template slot="paid_thru_date" slot-scope="{ rowData }" ><span v-html=prettyPaidThruDate(rowData.paid_thru_date)></span> </template>
            </va-data-table>
          </va-card>
        </div>
        <div class="flex md12">
          <va-card title="Users">
            <!-- <template slot="actions">
              <va-button @click="addUserToAccount"> Add </va-button>
            </template> -->

            <va-data-table :fields="fieldsUsers" :data="accountUsersList" no-pagination no-data-label="No users" hoverable ext-link-field="__slot:extlink" v-if="!accountUsersListLoading" style="height: 20vh">
                    <template slot="last_login" slot-scope="{ rowData }">{{ prettyLastLogin(rowData) }}</template>
            </va-data-table>
          </va-card>
        </div>
      </div>
    </div>

    <va-modal v-model="showAddSiteDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Add Site to Account">
      <form>
        <va-select label="Site" v-model="dialogSiteVal" :options="allSitesList" :clearValue="allSitesList[0]" :noClear="true" :clearOnMount="false" searchable style="width: 30vw" />
      </form>

      <template slot="actions">
        <va-button @click="dialogAdd">Add</va-button>
        <va-button @click="dialogCancel">Cancel</va-button>
      </template>
      <span v-if="showSaving">Adding...</span>
      <span style="color: red">{{ errorAdding }}</span>
    </va-modal>
  </div>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'
import { prettyPaidThruDate, formatDate } from '@/common'

export default {
  data() {
    return {
      accountSitesList: [],
      accountSitesListLoading: false,

      accountUsersList: [],
      accountUsersListLoading: false,

      showAddSiteDialog: false,
      allSitesList: [],
      allSitesListLoading: false,
      dialogSiteVal: null,
      errorAdding: '',

      item: {},
      itemOrig: null,
      showChangesWarning: false,
      showSaving: false,
      showSaved: false,
    }
  },
  computed: {
    fields() {
      return [
        { name: 'name', sortField: 'name', title: 'Name' },
        { name: 'city', sortField: 'city', title: 'City' },
        { name: 'state', sortField: 'state', title: 'State' },
        { name: '__slot:paid_thru_date', sortField: 'paid_thru_date', title: 'Paid Thru' },
      ]
    },
    fieldsUsers() {
      return [
        { name: 'name', sortField: 'name', title: 'Name' },
        { name: 'email', sortField: 'email', title: 'Email' },
        { name: '__slot:last_login', sortField: 'last_login', title: 'Last Login' },
      ]
    },
    hasDataChanged() {
      if (!this.itemOrig) {
        return false
      }
      for (let key of Object.keys(this.itemOrig)) {
        if (this.itemOrig[key] !== this.item[key]) {
          return true
        }
      }
      return false
    },
  },

  methods: {
    prettyPaidThruDate,
    async mainSave() {
      console.log('YES, SAVE', this.item)
      this.showChangesWarning = false
      this.showSaving = true
      let resp = await hiqapi.postPutWait('put', '/accounts/' + this.item.id, this.item)
      this.showSaving = false

      console.log('BACK resp=', resp)

      if (resp.status !== 200) {
        console.log(resp)
        this.showToast(`Error: ${resp.data.message}`, {
          position: 'top-center',
          duration: 6000,
        })

        return
      }
      this.showSaved = true
      setTimeout(() => (this.showSaved = false), 2000)

      this.itemOrig = { ...this.item }
      this.reloadSubLists()
    },
    prettyLastLogin(rowData) {
      return formatDate(rowData.date_last_login)
    },

    mainCancel() {
      console.log('NO SAVE')
      this.showChangesWarning = false

      this.item = { ...this.itemOrig }
    },

    reloadSubLists() {
      this.$root.$emit('reload_account_list', null, null)
      this.$root.$emit('reload_site_list', null, null)
    },

    // Add site to account

    addSiteToAccount() {
      if (this.showAddSiteDialog) {
        return
      }
      hiqapi.getcb('/sites', this.setDataAllSites)

      console.log('ADD')
      this.showSaving = false
      this.errorAdding = ''
      this.showAddSiteDialog = true
    },

    async dialogAdd() {
      console.log('SAVE ', this.item.id, this.dialogSiteVal.id)
      this.errorSaving = ''
      this.showSaving = true

      let data = {
        account_id: this.item.id,
        site_id: this.dialogSiteVal.id,
      }

      let resp = await hiqapi.postPutWait('post', '/account-sites', data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorAdding = resp.data.message
      } else {
        this.showToast('Site added', {
          position: 'top-right',
        })

        this.showAddSiteDialog = false
      }

      this.accountSitesListLoading = true
      hiqapi.getcb(`/sites?account_id=${this.item.id}`, this.setDataAccountSites)
    },

    dialogCancel() {
      console.log('CANCEL')
      this.showAddSiteDialog = false
    },

    setDataAccountSites(newval) {
      this.accountSitesListLoading = false
      this.accountSitesList = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.accountSitesList.forEach((item) => {
        item['item_id'] = item['id'].toString()
        if (item.paid_thru_date) {
          item.paid_thru_date = item.paid_thru_date.slice(0, 10)
        }
        for (let f in item) {
          if (!item[f]) {
            item[f] = '' // change nulls to empty strings
          }
        }
      })
      this.accountSitesList.sort((a, b) => {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      })

      console.log('AccountDetails SiteList SET DATA: ', newval)
    },
    setDataAccountUsers(newval) {
      this.accountUsersListLoading = false
      this.accountUsersList = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.accountUsersList.forEach((item) => {
        item['item_id'] = item['id'].toString()
        for (let f in item) {
          if (!item[f]) {
            item[f] = '' // change nulls to empty strings
          }
        }
        item['name'] = item['first_name'] + ' ' + item['last_name']
      })
      this.accountUsersList.sort((a, b) => {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      })

      console.log('AccountDetails UserList SET DATA: ', newval)
    },

    setDataAllSites(newval) {
      this.allSitesList = []
      if (!newval) {
        return
      }
      newval.items.forEach((item) => this.allSitesList.push({ id: '' + item.id, text: item.name }))

      this.allSitesList.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0))
      console.log('Add site list (all sites): ', newval, this.allSitesList)
    },
  },

  mounted() {
    this.$root.$on('account_selected', (arg1, arg2) => {
      if (this.hasDataChanged) {
        this.showChangesWarning = true
        return
      }
      this.showChangesWarning = false

      this.itemOrig = arg1
      this.item = { ...arg1 }
      console.log('UD Message received: ', arg1, arg2)

      console.log('itemOrig ===> ', this.itemOrig)

      this.accountSitesListLoading = true
      this.accountUsersListLoading = true
      hiqapi.getcb(`/sites?account_id=${this.item.id}`, this.setDataAccountSites)
      hiqapi.getcb(`/users?account_id=${this.item.id}`, this.setDataAccountUsers)
    })
  },
}
</script>

<style scoped>
.notif {
  align-self: center;
  padding-left: 40px;
}
</style>
